/**
 * Main layout wrapper for consistent page structure
 */

import { ReactNode } from 'react';
import { Header } from '@/components/navigation/Header';
import { Footer } from '@/components/Footer';

type Props = {
  children: ReactNode;
  showFooter?: boolean;
};

export function MainLayout({ children, showFooter = true }: Props) {
  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-1">
        {children}
      </main>
      {showFooter && <Footer />}
    </div>
  );
}
